/**
 * The platform rejects authorization-code exchanges from temporary development
 * preview origins while a separation freeze is active. Keep public domains on
 * their own callback origin, but route preview-initiated sign-ins through the
 * canonical published application instead.
 */
export const CANONICAL_PUBLIC_APP_ORIGIN = "https://weganumber.suryc.space";

export function resolveOAuthRedirectOrigin(
  currentOrigin: string,
  canonicalOrigin: string = CANONICAL_PUBLIC_APP_ORIGIN,
): string {
  const normalizedCanonicalOrigin = canonicalOrigin.replace(/\/$/, "");

  try {
    const currentUrl = new URL(currentOrigin);
    const isTemporaryPreview = currentUrl.hostname.endsWith(".manus.computer");
    const isLocalDevelopment = ["localhost", "127.0.0.1"].includes(currentUrl.hostname);

    if (isTemporaryPreview || isLocalDevelopment) {
      return normalizedCanonicalOrigin;
    }

    return currentUrl.origin;
  } catch {
    return normalizedCanonicalOrigin;
  }
}
